"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
var useStyles = function useStyles(props) {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccMenuHeaderStyle = (0, _react.useMemo)(function () {
    var ccMenuHeader = (0, _css.css)({});
    var ccMenuHeaderTitle = (0, _css.css)({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingInlineStart: pxToRem(8),
      paddingInlineEnd: pxToRem(21),
      paddingBottom: pxToRem(12),
      height: pxToRem(36)
    });
    return {
      ccMenuHeader: ccMenuHeader,
      ccMenuHeaderTitle: ccMenuHeaderTitle
    };
  }, [pxToRem]);
  return {
    'cc-Menu__header': ccMenuHeaderStyle.ccMenuHeader,
    'cc-Menu__header__title': ccMenuHeaderStyle.ccMenuHeaderTitle
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;